import { useNavigate } from "react-router-dom";
import logo from '../img/vivosol-logo.webp';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useEffect } from "react";
import { useAuth0 } from '@auth0/auth0-react';
import { shouldUseAuth0 } from '../auth/auth0Config';

function Auth0Logout() {
  const { logout } = useAuth0();

  useEffect(() => {
    document.title = "Vivosol Plant Performance Insights Hub - Logout";

    logout({
      logoutParams: {
        returnTo: window.location.origin
      }
    });
  }, [logout]);

  return (
    <div className="logoutBackground">
      <div className="container">
        <div className="login d-flex flex-column justify-content-center col-lg-5 col-sm-8 col-11 m-auto">
          <form className="px-5 py-5 pt-4">
            <img src={logo} className="logo mb-3" alt="Vivosol" />
            <p className="mb-5">Logging out...</p>
          </form>
        </div>
      </div>
    </div>
  );
}

function LogoutPage() {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Vivosol Plant Performance Insights Hub - Logout";
  }, []);

  return (
    <div className="logoutBackground">
      <div className="container">
        <div className="login d-flex flex-column justify-content-center col-lg-5 col-sm-8 col-11 m-auto">
          <form className="px-5 py-5 pt-4">
            <img src={logo} className="logo mb-3" alt="Vivosol" />
            <p className="mb-5">
              You have successfully logged out.
            </p>
            <button type="button" className="btn btn-primary w-100" onClick={() => navigate("/login")}>
              RETURN TO LOGIN
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

function Logout() {
  if (shouldUseAuth0()) {
    return <Auth0Logout />;
  }

  return <LogoutPage />;
}

export default Logout;
